export const FORMS_REQUEST_REQUEST = 'FORMS_REQUEST_REQUEST';
export const FORMS_REQUEST_SUCCESS = 'FORMS_REQUEST_SUCCESS';
export const FORMS_REQUEST_ERROR = 'FORMS_REQUEST_ERROR';
export const FORMS_PRICE_REQUEST = 'FORMS_PRICE_REQUEST';
export const FORMS_PRICE_SUCCESS = 'FORMS_PRICE_SUCCESS';
export const FORMS_PRICE_ERROR = 'FORMS_PRICE_ERROR';
